import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { FhqUsersState } from '@reducers/fhq-users';

export const getFhqUsers = (state: RootState): FhqUsersState => state.fhqUsers;
export const getFhqUsersData = createSelector(getFhqUsers, (users) => users?.data);
export const isFhqUsersLoading = createSelector(getFhqUsers, (users) => users?.loading);
